"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEditorialProducts = void 0;
var _productBox = require("@ori/product-box");
var _staticApiClientReact = require("@ori/static-api-client-react");
/* istanbul ignore file @preserve */

const getEditorialProducts = async ({
  fetchParams,
  isAnonymousUser,
  productCodes,
  staticApiClient,
  tenant
}) => {
  const {
    data: {
      data
    }
  } = await (0, _staticApiClientReact.getTenantApplicationsProductBox)(staticApiClient, tenant, {
    ...fetchParams,
    productCodes
  });
  const {
    products
  } = data ?? {};
  if (!products) {
    return [];
  }
  return (0, _productBox.mapProductBoxesFromStaticApi)({
    data: products,
    mode: _productBox.ProductBoxMode.Product,
    isAnonymousUser
  });
};
exports.getEditorialProducts = getEditorialProducts;
